import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { colors } from "healthex-common/colors";
import styled, { css } from "styled-components";
import { HXTextField } from "./base.styles";
export const SearchTextField = styled(HXTextField) `
    width: 650px;

    ${(props) => props.stretch &&
    css `
            width: auto;
            align-self: stretch;
        `}

    ${(props) => props.grow &&
    css `
            width: auto;
            flex: 1 0 0;
        `}
`;
export const SearchTextFieldIcon = styled(SearchIcon) `
    font-size: 24px !important;
`;
export const ClearTextFieldIcon = styled(ClearIcon) `
    font-size: 24px !important;
    color: ${colors.black_lighter};
`;
